export default __webpack_public_path__ + "static/media/wash.b7a10f19.svg";